import "../Channel.scss";
import { useEffect } from "react";
import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import LoginComponent from "../../../components/channel/login/LoginComponent";

const Login = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user);
	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);
	const channelId = queryJson?.id;

	useEffect(() => {
		if (reduxChannel?.influencer_id) {
			sessionStorage.setItem("influencer_id", reduxChannel?.influencer_id);
			sessionStorage.setItem("influencer_user_id", reduxChannel?.user_id);
			// if (channelId) {
			//     if (reduxChannel?.user_id !== 8 || reduxChannel?.user_id !== 1) {
			//         if (!(channelId === 'squidtv' || channelId === 'admin')) {
			//             history.replace(`/together/channel?id=${channelId}`);
			//         }
			//     }
			if (cUser?.id) {
				history.goBack();
			}
			// }
		}
	}, [reduxChannel, cUser]);
	// if (!!reduxChannel?.influencer_id) {
	return (
		<div className={`channel-wrap channel-home channel-delay`}>
			<div className={`home-body home-each`}>
				<div className={`max-width-apply`}>
					<div className={`home-recommend-horizontal`}>
						{reduxChannel?.user_id && reduxChannel?.user_id !== 7 ? (
							<div className={`channel-login-letter`}>
								<img
									src={`/assets/images/landing/welcome.png`}
									alt={`welcome`}
								/>
								<p className={`login-letter`}>
									안녕하세요 {reduxChannel?.name}입니다.
									{"\n"}
									{"\n"}
									유튜브 {reduxChannel?.nickname}의 소통 공간입니다.{"\n"}
									채널에서 소개해드린 건강정보나 다양한 이야기를 정리하여
									공유드릴 예정이며{"\n"}
									구독자분들과 편안하게 이야기를 나누고 건강 정보를 공유하는
									공간이 되었으면 합니다.
									{"\n"}
									{"\n"}
									구독자분들과의 특별한 공간이 되었으면해서 로그인 시
									입장가능하게 설정하였으니{"\n"}
									다소 번거로우시겠지만 양해부탁드립니다^^
								</p>
							</div>
						) : (
							<div className={`home-recommend-horizontal sign-up-div`}>
								<div className={`recommend-title`}>
									<p
										className={`title`}
										style={{
											margin: "2em 0",
										}}
									>
										로그인/회원가입
									</p>
								</div>
							</div>
						)}
						<LoginComponent />
					</div>
				</div>
			</div>
		</div>
	);
	// }
	// else {
	//     return (
	//         <></>
	//     )
	// }
};
export default Login;
